import { render, staticRenderFns } from "./OnboardingQuestionEmail.vue?vue&type=template&id=61105d50"
import script from "./OnboardingQuestionEmail.vue?vue&type=script&lang=js"
export * from "./OnboardingQuestionEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports